import React, { memo, useEffect, useState } from 'react'

const TimerWidget = ({ type, defaultValue, min, max, maxLength, handleTimerInputCB }) => {

    const [value, setValue] = useState(defaultValue);

    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    const onChange = (e) => {
        let val = Number(e.target.value);
        if (val > parseInt(max)) {
            val = parseInt(max);
        } else if (val < parseInt(min)) {
            val = 0;
        }
        setValue(val);
        handleTimerInputCB(val, type);
    }
    return (
        <div className='timerDiv'>
            <input className='timerDiv__input' type='number' value={value}
                onChange={onChange}
                min={min}
                max={max}
                maxLength={maxLength}
            />
        </div>
    )
}

export default memo(TimerWidget)
